import { createFileRoute } from "@tanstack/react-router";
import ThankYouSaint from "@/pages/ThankYouSaint";

const SITE_URL = "https://neurowellnesstms.com";

export const Route = createFileRoute("/thank-you-saint")({
  head: () => ({
    meta: [
      { name: "robots", content: "noindex, follow" },
      { title: "Thank You — SAINT® Consult | Neuro Wellness TMS" },
      {
        name: "description",
        content:
          "Thank you for requesting a SAINT® TMS consultation. Our Coral Springs, FL team will contact you about your 5-day depression treatment plan soon.",
      },
      { property: "og:title", content: "Book Your Free SAINT® Consult" },
      {
        property: "og:description",
        content:
          "Next step: book your free SAINT® consult with Neuro Wellness TMS Centers of America.",
      },
      { property: "og:url", content: `${SITE_URL}/thank-you-saint` },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/thank-you-saint` },
      { rel: "alternate", hrefLang: "en", href: `${SITE_URL}/thank-you-saint` },
      {
        rel: "alternate",
        hrefLang: "es",
        href: `${SITE_URL}/es/thank-you-saint`,
      },
      {
        rel: "alternate",
        hrefLang: "x-default",
        href: `${SITE_URL}/thank-you-saint`,
      },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <ThankYouSaint />;
}
